
const ExamMultiple = r => require(['@/v3/modules/report/views/multiple/index'], r)
 const ExamMultipleCreateOld = r => require(['@/v3/modules/report/views/multiple/create'], r)
const ExamMultipleCreate = r => require(['@/v3/modules/report/views/multiple/create-custom'], r)
export default [
  {
    path: '/exam/multiple',
    name: 'exam-multiple',
    meta: { auth: ['Exam-Multiple', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Region-Exam-Single'], keepAlive: true, checkAuth: true, url: '/v2/exam/index', parentPath: '/v2/exam/index' },
    component: ExamMultiple
  },
  {
    path: '/exam/multiple/create',
    meta: { auth: ['Exam-Multiple', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Region-Exam-Single'], keepAlive: true, checkAuth: true, url: '/v2/exam/index', parentPath: '/v2/exam/index' },
    component: ExamMultipleCreate
  },
  {
    path: '/exam/multiple/edit/:id',
    name: 'exam-multiple-edit',
    meta: { auth: ['Exam-Multiple', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Region-Exam-Single'], keepAlive: true, checkAuth: true, url: '/v2/exam/index', parentPath: '/v2/exam/index' },
    component: ExamMultipleCreate
  },
  {
    path: '/exam/multiple/create_old/:id',
    name: 'exam-multiple-create-old',
    meta: { auth: ['Exam-Multiple', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Region-Exam-Single'], keepAlive: true, checkAuth: true, url: '/v2/exam/index', parentPath: '/v2/exam/index' },
    component: ExamMultipleCreateOld
  },
  {
    path: '/exam/multiple/edit_old/:id',
    name: 'exam-multiple-edit-old',
    meta: { auth: ['Exam-Multiple', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Region-Exam-Single'], keepAlive: true, checkAuth: true, url: '/v2/exam/index', parentPath: '/v2/exam/index' },
    component: ExamMultipleCreateOld
  }
]
